export enum FileMenuOption {
  NEW = 'new',
  DUPLICATE = 'duplicate',
  VERSION_HISTORY = 'version-history',
  SETTINGS = 'settings',
  HELP_CENTER = 'help-center',
}

export const FILE_MENU_HELP_CENTER_URL = 'https://support.postermywall.com/hc/en-us/sections/7673955928461-Email-Maker?utm_source=editor&utm_medium=nav';

export const FILE_MENU_NEW_URL = 'emailmaker/start';
export const FILE_MENU_SETTINGS_URL = 'posters/mine#/email-marketing-campaign-settings';
